<template>
  <div>
    <div v-if="!isLoading" class="box box-default">
      <div class="box-header">
        <div class="flex align-items-center justify-between">
          <h3 class="box-title">Trade Flex</h3>
          <div v-if="tab === 'search'" class="flex align-items-center">
            <span class="text-bold text-danger">{{ searching }}</span>
            <select v-model="status" class="ml-8 form-control" aria-label="">
              <option value="">TradeFlex Status - All</option>
              <option value="1">Open</option>
              <option value="2">Fulfilled</option>
              <option value="3">Cancelled</option>
            </select>
            <v-select v-model="userId" :clearable="false" :options="merchants"
                      :reduce="m => m.ID"
                      class="ml-8" label="Name" style="min-width: 350px;" taggable></v-select>
            <input v-model="keyword" aria-label="search" class="form-control ml-8" placeholder="Search..."
                   ref="searchInput" @keydown.enter="getPaginatedRecords(1, false)" style="min-width: 250px;" type="text"/>
            <button class="btn btn-primary btn-flat btn-sm ml-8 mr-8" @click="getPaginatedRecords(1, false)">Search
            </button>
          </div>
        </div>
      </div>
      <div class="box-body no-padding">
        <va-tabs @selectedTab="selectedTab">
          <div id="latest" slot="content" :title="'Last 1000 Actions'" class="active">
            <trade-flex-listing :records="latestRecords"></trade-flex-listing>
          </div>
          <div id="search" slot="content" :title="'Search Results'">
            <trade-flex-search-listing :records="records" :meta="meta" @updatePage="updatePage" @sort="sort"></trade-flex-search-listing>
          </div>
        </va-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import VaTabs from '@/components/VATabs'
import TradeFlexListing from '@/components/tradeflex/TradeFlexListing'
import { mapGetters } from 'vuex'
import { LIST_MERCHANTS, START_LOADING, STOP_LOADING } from '@/store/keys'
import { saveNotification } from '@/lib/utils'
import TradeFlexSearchListing from '../components/tradeflex/TradeFlexSearchListing'

export default {
  name: 'TradeFlex',
  components: {
    TradeFlexSearchListing,
    VaTabs,
    TradeFlexListing
  },
  data() {
    return {
      latestRecords: [],
      records: [],
      meta: {
        total: 0,
        page: 1,
        offset: 0,
        limit: Number.parseInt(process.env.VUE_APP_LIMIT, 10)
      },
      keyword: '',
      searching: '',
      userId: null,
      id: '',
      status: '',
      tab: 'latest'
    }
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'jwtToken',
      'currentUser',
      'merchants'
    ])
  },
  watch: {
    $route(to, from) {
      this.id = ''
      if (to.query.id !== from.query.id && to.query.merchant_id !== from.query.merchant_id) {
        if (to.query.merchant_id) {
          this.userId = to.query.merchant_id
        }
        if (to.query.id) {
          this.id = to.query.id
        }
        this.getPaginatedRecords()
      }
    }
  },
  methods: {
    selectedTab(id) {
      this.tab = id
    },
    showLoading() {
      this.$swal.fire({
        title: '',
        text: 'Please wait...',
        showConfirmButton: false,
        backdrop: true
      })
    },
    stopLoading() {
      this.$swal.close()
    },
    updatePage(page) {
      this.getPaginatedRecords(page)
    },
    sort(key) {
      if (key !== this.sortKey) {
        this.order = 'desc'
      } else {
        this.order = this.order === 'asc' ? 'desc' : 'asc'
      }
      this.sortKey = key
      this.getPaginatedRecords(1, false)
    },
    getLatestRecords() {
      this.$store.commit(START_LOADING)
      const apiBaseUrl = process.env.VUE_APP_ADMIN_API_URL
      this.$http.get(`${apiBaseUrl}/?Call=ListMisc&type=trade_flex_latest`, {
        headers: {
          Authorization: 'Bearer ' + this.jwtToken
        }
      }).then((response) => {
        this.$store.commit(STOP_LOADING)
        this.searching = ''
        if (response.status === 200) {
          this.latestRecords = response.data.data
        }
      }).catch(error => {
        this.$store.commit(STOP_LOADING)
        this.searching = ''
        this.$toast.fire('', error.data.message, 'error')
        saveNotification(error.data.message)
      })
    },
    getPaginatedRecords(page = 1, isLoader = true) {
      this.userId = this.userId ? this.userId : Number.parseInt(this.currentUser.ID, 10)
      if (isLoader) {
        this.$store.commit(START_LOADING)
      } else {
        this.id = ''
        this.searching = 'Searching...'
      }
      const apiBaseUrl = process.env.VUE_APP_ADMIN_API_URL
      this.$http.get(`${apiBaseUrl}/?Call=ListMisc&type=trade_flex`, {
        headers: {
          Authorization: 'Bearer ' + this.jwtToken
        },
        params: {
          page,
          keyword: this.keyword ? this.keyword.trim() : '',
          merchantID: this.userId,
          id: this.id,
          status: this.status,
          limit: Number.parseInt(this.meta.limit),
          order: this.sortKey,
          orderBy: this.order
        }
      }).then((response) => {
        this.$store.commit(STOP_LOADING)
        this.searching = ''
        if (response.status === 200) {
          this.records = response.data.data.records
          this.meta = response.data.data.meta
          if (this.keyword) {
            this.$nextTick(() => this.$refs.searchInput.focus())
          }
        }
      }).catch(error => {
        this.$store.commit(STOP_LOADING)
        this.searching = ''
        this.$toast.fire('', error.data.message, 'error')
        saveNotification(error.data.message)
      })
    },
    getRecordById(id, index) {
      const apiBaseUrl = process.env.VUE_APP_ADMIN_API_URL
      this.$http.get(`${apiBaseUrl}/?Call=ListMisc&type=trade_flex`, {
        headers: {
          Authorization: 'Bearer ' + this.jwtToken
        },
        params: {
          id,
          obj: true
        }
      }).then((response) => {
        if (response.status === 200) {
          const record = response.data.data
          this.records.splice(index, 1, record)
        }
      }).catch(error => {
        this.$toast.fire('', error.data.message, 'error')
      })
    },
    handleSlashKey(e) {
      if (e.key === '/') {
        e.preventDefault()
        this.$refs.searchInput.focus()
      }
    }
  },
  mounted() {
    this.sortKey = 'CreatedOn'
    this.order = 'desc'
    this.getLatestRecords()
    this.$store.dispatch(LIST_MERCHANTS, { type: 'TradeFlex' })
    window.addEventListener('keydown', this.handleSlashKey)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleSlashKey)
    this.$store.commit(STOP_LOADING)
  }
}
</script>

<style scoped></style>
